import React, { useEffect, useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import { getReturnedItems } from "store/return-request/return-request-action"
import ReturnRequestListComponent from "components/ReturnRequest/list"

const ReturnedItemsList = () => {
  document.title = " Re-allocation"

  const dispatch = useDispatch()
  const { data, loading } = useSelector(state => state.returnRequest)
  const [pageNumber, setPageNumber] = useState(10)

  useEffect(() => {
    dispatch(getReturnedItems(pageNumber))
  }, [pageNumber])

  const onPageClick = () => {
    dispatch(getReturnedItems(pageNumber))
  }

  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  return (
    <div className="page-content">
      <Breadcrumbs title=" Re-allocation" breadcrumbItem=" Re-allocation" />
      <ReturnRequestListComponent
        data={data}
        loading={loading}
        onPageClick={onPageClick}
        onChangeRowNumber={onChangeRowNumber}
        selectedIds={[]}
        onCheckboxChange={() => {}}
        onSelectAll={() => {}}
        onApprove={() => {}}
        onReject={() => {}}
        adminNote=""
        onAdminNoteChange={() => {}}
        showActions={false}
        showAdminNote={false}
      />
    </div>
  )
}

export default ReturnedItemsList
